<template>
    <div class="absolute inset-0">
        <img
            v-if="hud"
            :src="hud"
            alt=""
            class="pointer-events-none absolute top-0 left-1/2 max-w-none -translate-x-1/2"
        />
        <h2
            class="font-title absolute inset-x-0 top-[197px] text-center text-[24px] leading-none font-bold text-white uppercase"
        >
            {{ player.tag_name }}
        </h2>
        <div class="absolute top-[239px] left-[87px] w-[228px]">
            <KillerAvatarFrame :color="color">
                <KillerAvatar
                    :avatar="player.avatar"
                    :color="color"
                    class="w-full"
                    :class="{ 'opacity-40': isKiller }"
                />
                <KillerSkullIcon v-if="isKiller" :color="color" class="absolute w-[79%]" />
            </KillerAvatarFrame>
        </div>
        <div class="absolute inset-x-0 top-[505px] flex flex-col items-center gap-[42px]">
            <KillerSplashTitle>{{ title }}</KillerSplashTitle>
            <div
                class="font-title text-titles self-stretch px-14 text-center text-[11px] leading-3.5 font-medium uppercase"
            >
                {{ hint }}
            </div>
        </div>
    </div>
</template>

<script>
import KillerSplashTitle from './KillerSplashTitle.vue'
import KillerAvatar from '../ui/KillerAvatar.vue'
import KillerAvatarFrame from '../ui/KillerAvatarFrame.vue'
import KillerSkullIcon from '../ui/KillerSkullIcon.vue'

export default {
    name: 'KillerSplashPlayer',
    components: {
        KillerSplashTitle,
        KillerAvatar,
        KillerAvatarFrame,
        KillerSkullIcon,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            required: true,
        },
        isKiller: {
            type: Boolean,
            default: false,
        },
        hud: {
            type: String,
            default: null,
        },
    },
}
</script>
